import { Typography } from '@beeline/design-system-react/extracted-styles';
import { Icons } from '@beeline/design-tokens/js/iconfont/icons';

import styles from './styles.module.scss';

import { Link } from ':components';
import { CustomIcon } from ':components/CustomIcon';
import { MAP_ICONS } from ':constants';

interface WidgetTitleProps {
  iconName: string;
  iconBgColor: string;
  iconColor: string;
  title: string;
}

export function WidgetTitle({
  iconName,
  iconBgColor,
  iconColor,
  title,
}: WidgetTitleProps) {
  const isIcon = (str: string): str is Icons => MAP_ICONS.has(str as Icons);
  const res = isIcon(iconName);
  return (
    <div className={styles.title}>
      <CustomIcon
        iconName={res ? iconName : Icons.Puzzle}
        background={iconBgColor}
        color={iconColor}
      />
      <Typography className={styles.name} variant='h6'>
        {title}
      </Typography>
    </div>
  );
}

interface WidgetTitleRef extends WidgetTitleProps {
  url?: string;
}

export function WidgetTitleRef({ url, ...props }: WidgetTitleRef) {
  return url ? (
    <Link to={url} className={styles.link} noWrapper disableTextDecoration>
      <WidgetTitle {...props} />
    </Link>
  ) : (
    <WidgetTitle {...props} />
  );
}
